import React, { Fragment } from "react";

const About = () => {
  return (
    <Fragment>
      <div className="about">
        <div className="container py-5">
          <div className=" p-2 p-md-3 bg-body rounded text-center about-me-text text-light">
            A passionate front-end web dev, enthusiastic in coding and making
            great sites. All of my projects are here that I made throughout my
            journey{" "}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default About;
